import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  ja: {
    トイレ可視化: {
      ホームタイトル: "夢洲駅",
      使い方ボタン: "使い方",
      使い方: {
        タイトル: "使い方",
        メッセージ: "トイレ施設空き状況をご確認いただけます。",
        利用状況: "利用状況",
        利用状況説明: "利用状況は以下のように表示されます。",
        空きあり: "空きあり",
        空きなし: "空きなし",
        利用不可: "利用できません",
        利用可能: "利用することができます",
        設備説明: "設備説明",
      },
      空き個室: "空き個室",
      空きあり: "空きあり",
      空きなし: "空きなし",
      取得失敗: "情報が取得できませんでした。\n再度お試しください。",
      再試行: "再試行",
      注釈: "※実際の空き状況と異なる場合があります"
    },
  },
  en: {},
};

i18n.use(initReactI18next).init({
  resources,
  lng: "ja", // 言語設定の初期値を設定
  fallbackLng: "en", // 言語とキーに紐づく辞書情報が無い場合の表示言語を設定
  interpolation: {
    escapeValue: false, // XSS対策はReact側で行うため不要
  },
  debug: false, // コンソールにデバッグ情報を表示
});

export default i18n;
export { resources };
